import { APP_CONFIG } from '../config.js';

export default {
    /*
    GET /api/player/album/{id}
    To get tracks from an album
    */
    getAlbumTracks: function(albumId) {
        return axios.get(APP_CONFIG.API_URL + '/player/album/' + albumId);
    },

    /*
    GET /api/player/track/{id}
    To get a track
    */
    getTrack: function(trackId) {
        return axios.get(APP_CONFIG.API_URL + '/player/track/' + trackId);
    },
}
